module.exports = __webpack_public_path__ + "img/cons_7.73fd3bca.jpg";